<template>
  <div>
    <b-modal
      id="see-transacion"
      v-model="modalShow"
      cancel-variant="outline-secondary"
      centered
      hide-footer
      size="xl"
      :title="'Transactions '+ walletName"
    >
    <b-overlay :show="loadingData" variant="transparent" no-wrap />
    
    <b-modal
      ref="my-modal"
      id="modal-bonus"
      centered
      hide-footer
      size="xl"
      title="Bonus">

      <table role="table" aria-busy="false" aria-colcount="3" class="table b-table table-striped">
        <thead role="rowgroup" class="">
            <tr role="row" class="">
              <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Name</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Description</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div v-if="typeTransaction == 'credit'">Currency</div>
                  <div v-else>Amount</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Expiry Time</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Rollover</div>
              </th>
               <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Actions</div>
              </th>
            </tr>
        </thead>
        <tbody role="rowgroup">
          <tr>
            <td>
                <b-form-input v-model="bonus.name" placeholder="Name" :readonly="disabled"/>
            </td>
            <td>
                <b-form-input v-model="bonus.description" placeholder="Description" :readonly="disabled"/>
            </td>

            <td v-if="typeTransaction == 'credit' && !showRealButton">
              {{ bonus.currency.balance +' '+bonus.currency.currency }}
            </td>
            <td v-else>
              <b-form-input v-model="bonus.amount" placeholder="Amount"/>
            </td>

            <td>
              <b-form-select v-model="bonus.expiration_time" :options="expirationTimeOptions" :disabled="disabled"></b-form-select>
            </td>
            <td>
               <b-form-input v-model="bonus.rollover" placeholder="Rollover" :readonly="disabled"/>
            </td>
            <td>
                <b-button
                  v-if="credithiddenButton"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="typeTransaction == 'credit' ? 'success' : 'outline-secondary'"
                  @click="setTypeTransaction('credit')">
                    Credit
                </b-button>

                <div v-if="!showRealButton">
                  
                <a v-if="hiddenButton" @click="showRealButton = !showRealButton">
                    Debit
                </a>

                 <a v-if="hiddenButton" @click="showRealButton = !showRealButton">
                    Withdrawals
                </a>

                </div>

                <b-button
                  v-if="showRealButton"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="typeTransaction == 'debit' ? 'danger' : 'outline-secondary'"
                  @click="setTypeTransaction('debit')">
                    Debit
                </b-button>
                <b-button
                  v-if="showRealButton"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="typeTransaction == 'withdrawals' ? 'dark' : 'outline-secondary'"
                  @click="setTypeTransaction('withdrawals')">
                    Withdrawals
                </b-button>

            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>

        <b-modal
      ref="mymodaltransaction"
      v-model="modalShowTransaction"
      id="modal-transaction"
      centered
      hide-footer
      :title="`ID transaction: ${transaction._id}`">

      <div>
        Wallet Name: <strong>{{walletName}}</strong>
      </div>

      <div>
        Operation: <strong>
          <b-badge v-if="transaction.from=== 'credit'" pill variant="success" class="text-white">Credit</b-badge>
        <b-badge v-else-if="transaction.from=== 'debit'" pill variant="danger" class="text-white">Debit</b-badge>
          </strong>
      </div>

      <div>
        Amount: <strong>{{transaction.balance.amount | currency({ symbol: '' }) }}</strong>
      </div>

      <div>
        Balance: <strong>{{transaction.balance.currentBalance}}</strong>
      </div>

      <div>
        Currency: <strong>{{transaction.balance.currency}}</strong>
      </div>

      <div>
        Platform: <strong>{{ transaction.details.platformName }}</strong>
      </div>
    </b-modal>

    <!-- table -->
    <vue-good-table
    class="table-responsive"
      :columns="columns"
      :rows="transactionsWallet"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'reference'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.reference }}</span>
        </div>
        <span class="text-center" v-else-if="props.column.field === 'credit'">
          <p v-if="props.row.from === 'credit'">{{ props.row.balance.amount | currency({ symbol: '' }) }}</p>
        </span>

        <span class="text-center" v-else-if="props.column.field === 'debit'">
          <p v-if="props.row.from === 'debit'">- {{ props.row.balance.amount | currency({ symbol: '' }) }}</p>
        </span>
        <span class="text-center" v-else-if="props.column.field === 'balance'">
          {{ props.row.balance.currentBalance | currency({ symbol: '' }) }}
        </span>

        <span v-else-if="props.column.field === 'currency'">
          {{ props.row.balance.currency }}
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <feather-icon
              @click="transaction = props.row"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-modal.modal-transaction
              icon="EyeIcon"
              size="16"
              class="text-body align-middle mr-25"
            />
          </span>
            <span>
              <img @click="setBonus(props.row)"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-bonus
                src="@/assets/images/svg/bonus.svg" 
                style="width: 30px;">
            </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['20', '40', '60', '100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    </b-modal>


  </div>
</template>

<script>
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, VBModal, BOverlay, BTable, BButton
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    
  },
  components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BOverlay,
        VBModal,
        BTable,
        BButton,
        ToastificationContent
    },
      directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      showRealButton: false,
      selectdisabledd: '',
      credithiddenButton: true,
      bonusId: null,
      disabled:false,
      hiddenButton: false,
      expirationTimeOptions: [30, 60, 120, 180],
      typeTransaction: "credit",
      modalShowTransaction: false,
      walletName: "",
      walletId: "",
      modalShow: false,
      loadingData: false,
      bonus: {
        amount: 0,
        currency: {},
        walletId: null,
        name: null,
        description: null,
        rollover: 0,
        expiration_time: 30,
        reference: null,
        details: {},
      },
      transaction: {
        _id: null,
        walletId: null,
        from: null,
        balance: {},
        details: {},
      },
      pageLength: 20,
      dir: false,
      columns: [
        {
          label: 'Reference',
          field: 'reference',
          filterOptions: {
            enabled: true,
            placeholder: 'Search reference',
          },
        },
        {
          label: 'Credit',
          field: 'credit',
        },
        {
          label: 'Debit',
          field: 'debit',
        },
        {
          label: 'Balance',
          field: 'balance',
        },
        {
          label: 'currency',
          field: 'currency',
          filterOptions: {
            enabled: true,
            placeholder: 'Search currency',
          },
        },
        {
          label: 'Platform',
          field: 'details.platformName',
        },
        {
          label: 'CreatedAt',
          field: 'createdAt',
          filterOptions: {
            enabled: true,
            placeholder: 'Search createdAt',
          },
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  watch: {
    modalShow(val) {
      if (val) {
        this.getWalletTransactions(this.walletId)
      }
    },
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disabled-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disabled-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    transactionsWallet() {
      return this.$store.state.wallet.transactionsWallet
    },
  },
  methods:{
    showTransactions({ walletId, walletName }) {
      this.walletId = walletId
      this.walletName = walletName
      this.modalShow = true
    },
    async getWalletTransactions(walletId){
      try {
        this.loadingData = true;
        await this.$store.dispatch('wallet/getWalletTransactions', walletId);
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching wallet list",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      } finally {
        this.loadingData = false;
      }
    },
    setBonus(props){
     this.bonus.currency = {
       balance: props.balance.currentBalance,
       currency: props.balance.currency,
     }
     this.bonus.walletId = props.walletId
    },
    setTypeTransaction(val){
      this.typeTransaction = val
      switch (val) {
        case 'credit':
          this.credit()
        break;

        case 'debit':
          this.debit()
        break;

        case 'withdrawals':
          this.withdrawals()
        break;
      }
    },
    async credit(){
      try{
          let res = await this.$store.dispatch('wallet/addBonus', this.bonus)
          // this.$bvModal.hide('modal-bonus')
          this.credithiddenButton = false
          this.hiddenButton = true
          this.disabled = true
          this.selectdisabledd = 'disabledd'
          this.bonusId = res.bonus._id
          this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'AlertTriangleIcon',
            variant: 'success',
            text: `${res.message}`,
          }})
      } catch(error){
          this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: `Crediting error`,
          }})
      }
    },
    async debit(){
      this.credithiddenButton = false
      console.log(this.bonusId)
      try{
          let res = await this.$store.dispatch('wallet/debitWithdrawalsBonus', { 
            bonusId: this.bonusId, from: 'debit', data: this.bonus 
          })
          this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'AlertTriangleIcon',
            variant: 'success',
            text: `${res.message}`,
          }})
      } catch(error){
        console.log(error)
          this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: `Crediting error`,
          }})
      }
    },
    async withdrawals(){
      console.log('withdrawals')
    },
  },

}
</script>